/**
 * @generated SignedSource<<bc45d8fce985ccebfb4772f106873455>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourceScreen_StripeConnectMutation$variables = {
  apiKey: string;
  token?: string | null | undefined;
};
export type sourceScreen_StripeConnectMutation$data = {
  readonly leadStripeConnect: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly lead: {
      readonly token: string;
    } | null | undefined;
  } | null | undefined;
};
export type sourceScreen_StripeConnectMutation = {
  response: sourceScreen_StripeConnectMutation$data;
  variables: sourceScreen_StripeConnectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "apiKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v2 = [
  {
    "kind": "Variable",
    "name": "apiKey",
    "variableName": "apiKey"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourceScreen_StripeConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LeadStripeConnectMutationPayload",
        "kind": "LinkedField",
        "name": "leadStripeConnect",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "sourceScreen_StripeConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "LeadStripeConnectMutationPayload",
        "kind": "LinkedField",
        "name": "leadStripeConnect",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9997f28dd3237ca1ac7780f437050c3f",
    "id": null,
    "metadata": {},
    "name": "sourceScreen_StripeConnectMutation",
    "operationKind": "mutation",
    "text": "mutation sourceScreen_StripeConnectMutation(\n  $token: String\n  $apiKey: String!\n) {\n  leadStripeConnect(token: $token, apiKey: $apiKey) {\n    lead {\n      token\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cedfa6771f567dd9f6b773352c466ece";

export default node;
